import React from 'react';
import { ChangeSubCategoryPosition } from './components/ChangeSubCategoryPosition';
import { ChangeSubCategoryPositionState } from './changeSubCategoryPositionState/ChangeSubCategoryPositionState';

export const ChangeSubCategoryPositionPageV2: React.FC = () => {
	return (
		<ChangeSubCategoryPositionState>
			<ChangeSubCategoryPosition />
		</ChangeSubCategoryPositionState>
	);
};
